exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-logo {\n  text-align: center; }\n\n.auth-block p {\n  text-align: center; }\n\n.auth-block {\n  background: #bf0a24 !important; }\n\n.funds-separator {\n  border-bottom: solid 1px #abb9be;\n  padding: 10px 0; }\n\n.funds-separator:last-child {\n  border-bottom: none; }\n\n.search--input {\n  margin-left: 0px;\n  padding-left: 10px;\n  width: 300px;\n  margin-bottom: 10px; }\n\n.table-hover > tbody > .active:before {\n  background-color: rgba(0, 0, 0, 0.1); }\n\n.content-top {\n  padding-top: 13px;\n  padding-bottom: 27px; }\n\nh1.al-title {\n  font-weight: 700;\n  color: #ffffff;\n  float: left;\n  width: auto;\n  margin: 0;\n  padding: 0;\n  font-size: 24px;\n  text-transform: uppercase;\n  opacity: 0.9; }\n\n.al-breadcrumb {\n  background: none;\n  color: #ffffff;\n  padding: 0;\n  margin: 0;\n  float: right;\n  padding-top: 11px; }\n  .al-breadcrumb li {\n    font-size: 18px;\n    font-weight: 400; }\n    .al-breadcrumb li a {\n      color: #4dc4ff; }\n    .al-breadcrumb li.breadcrumb-item.active {\n      color: #ffffff; }\n\n.al-look {\n  float: right;\n  margin-right: 10px;\n  padding-top: 10px; }\n  .al-look > a {\n    font-size: 19px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baContentTop/baContentTop.scss
// module id = 828
// module chunks = 8